import { apiFetch } from '@/lib/api/client';
import { AUTH_API } from '@/lib/api/urls';

import type { OptionItem } from '@/lib/api/types';

const salutationsCache = new Map<string, Promise<OptionItem[]>>();
const countriesCache = new Map<string, Promise<OptionItem[]>>();

export const fetchSiteSalutations = (
  tenantId: string,
  locale: string,
): Promise<OptionItem[]> => {
  const key = `${tenantId}:${locale || 'en'}`;
  if (!salutationsCache.has(key)) {
    salutationsCache.set(
      key,
      apiFetch<OptionItem[]>(AUTH_API.salutations, {
        auth: 'none',
        tenantId,
        locale: locale || 'en',
        omitHeaders: ['X-B2B-SESSION-ID'],
      }),
    );
  }
  return salutationsCache.get(key)!;
};

export const fetchSiteCountries = (tenantId: string): Promise<OptionItem[]> => {
  if (!countriesCache.has(tenantId)) {
    countriesCache.set(
      tenantId,
      apiFetch<OptionItem[]>(AUTH_API.countries, {
        auth: 'none',
        tenantId,
        omitHeaders: ['X-B2B-SESSION-ID'],
      }),
    );
  }
  return countriesCache.get(tenantId)!;
};
